import React from "react";
import { AuditLog } from "@common/types/auditLog";
import { FinancialDocument } from "@common/types/financialDocument";
import { pluralize } from "@common/helpers/string";
import styles from "./ChatTaskAuditLog.module.scss";

interface Props {
    log: AuditLog;
}

export const ChatTaskFinancialDocuments: React.FC<Props> = ({ log }) => {
    const beforeFinancialDocuments =
        (log.diff.find((d) => d.field === "financialDocuments")?.before
            ?.value as FinancialDocument[]) ?? [];
    const afterFinancialDocuments =
        (log.diff.find((d) => d.field === "financialDocuments")?.after
            ?.value as FinancialDocument[]) ?? [];

    const beforeIds = new Set(beforeFinancialDocuments.map((d) => d.id));
    const afterIds = new Set(afterFinancialDocuments.map((d) => d.id));

    const addedDocuments = afterFinancialDocuments.filter(
        (d) => !beforeIds.has(d.id),
    );
    const removedDocuments = beforeFinancialDocuments.filter(
        (d) => !afterIds.has(d.id),
    );

    const messages: string[] = [];
    if (removedDocuments.length > 0) {
        const names = removedDocuments.map((d) => d.fileName).join(", ");
        messages.push(
            `removed ${pluralize("document", removedDocuments.length)} ${names}`,
        );
    }
    if (addedDocuments.length > 0) {
        const names = addedDocuments.map((d) => d.fileName).join(", ");
        messages.push(
            `added ${pluralize("document", addedDocuments.length)} ${names}`,
        );
    }

    const message =
        messages.length > 0
            ? messages.join(" and ")
            : "changed financial documents";

    return <span className={styles.chatTaskMessage}>{message}</span>;
};
